module.exports = __webpack_public_path__ + "img/icon-generic-key.6488e6de.svg";